import styled, { css } from 'styled-components';
import type { IslandMode } from '../../BaseSimpleIsland';
import { PEEKING_HOVER_TRANSLATE } from '../../BaseSimpleIsland';


interface OnIslandOutcomeNodeContainerStyleProps {
  outcomeIslandMode: IslandMode;
  dimOutcome: boolean;
}

export const OnIslandOutcomeNodeContainer = styled.div<OnIslandOutcomeNodeContainerStyleProps>`
  ${p => p.outcomeIslandMode === 'peeking' && css`
    box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.35);
    &:hover {
      transform: translateX(-${PEEKING_HOVER_TRANSLATE}px);
    }
    transition: all 200ms cubic-bezier(0.25, 0.46, 0.45, 0.94);
  `}
  border-radius: var(--cl-radius-1);

  ${p => p.dimOutcome && css`
    opacity: 0.3;
  `}
`;
